import i18n from "../../../../constants/i18n";
import Et3Button from "../../../../core/et3-button";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import { isPositiveNumber } from "et3-type-guards";
import SubmitFinalReceipt from "./SubmitFinalReceipt";
import getRootStore from "../../../../stores/core/root-store";
import getSupervisorReceiptStore from "../../../../stores/supervisor-store/supervisor-receipt-compensation-store";
import SaveReceiptIssuesCount from "./SaveReceiptIssuesCount";
import Et3Picker from "../../../../core/et3-input/et3-picker";
import { reducerToZeroIfUndefined } from "../../../../helpers/et3-picker-data-helper";
import { TEt3PickerSingleValue } from "../../../../TypesNEW";

const SupervisorReceiptCompensationForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const allCsrAdmins = getRootStore().allCsrAdmins.get();
  const csrAdmin = getSupervisorReceiptStore().csrAdmins.get();
  const isGetButtonEnabled = isPositiveNumber(
    reducerToZeroIfUndefined(parseInt(csrAdmin.value, 10))
  );
  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      withShadow={false}
      width={1500}
      height={180}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="space-between"
        alignItems="flex-start"
        withShadow={false}
        width={1500}
        height={110}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Picker
          label={i18n.get("ADMIN")}
          options={allCsrAdmins}
          value={csrAdmin}
          onChoose={(value: TEt3PickerSingleValue) => {
            getSupervisorReceiptStore().setCSRAdmins(value);
          }}
          isMultiple={false}
          style={{}}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <SaveReceiptIssuesCount />
        <SubmitFinalReceipt />
      </ET3Div>
      <Et3Button
        onClick={async () => {
          await getSupervisorReceiptStore().getSupervisorReceiptCompensation();
        }}
        isEnabled={isGetButtonEnabled}
        size="LARGE"
        text="GET"
        type="GET"
      />
    </ET3Div>
  );
});
export default SupervisorReceiptCompensationForm;
